import { SourceUsageTableRow } from "../../../components/SourceTable";

export function rowsToExcelData(rows: SourceUsageTableRow[]): Record<string, string | number>[] {
    return rows.map((row) => ({
      "#": row.index,
      Source: row.name,
      "Domain type": row.domainType,
      Links: row.linksCount,
      "Usage %": row.usagePercent,
      Citations: row.citations,
      "Avg. citations":
        row.averageCitations != null ? row.averageCitations : "",
    }));
  }